import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth", // Name of the slice
  initialState: {
    isSignedIn: false, // Initial state for whether the user is signed in
    user: null, // Initial state for storing user information
    signUpStep: "signUp", // Initial state to manage the sign-up process step
    signUpError: null, // Initial state to handle sign-up errors
    signUpMessage: null, // Initial state to handle sign-up messages (e.g., success messages)
  },
  reducers: {
    // Reducer to set the signed-in state
    setIsSignedIn: (state, action) => {
      state.isSignedIn = action.payload;
    },
    // Reducer to set the user information
    setUser: (state, action) => {
      state.user = action.payload;
    },
    // Reducer to clear the user-related state, including sign-up details
    clearUserState: (state) => {
      state.isSignedIn = false; // Reset signed-in status
      state.user = null; // Clear user information
      state.signUpStep = "signUp"; // Reset sign-up step
      state.signUpError = null; // Clear any sign-up errors
      state.signUpMessage = null; // Clear any sign-up messages
    },
    // Reducer to set the current sign-up step
    setSignUpStep: (state, action) => {
      state.signUpStep = action.payload;
    },
    // Reducer to set the sign-up error message
    setSignUpError: (state, action) => {
      state.signUpError = action.payload;
    },
    // Reducer to set the sign-up success message or other relevant messages
    setSignUpMessage: (state, action) => {
      state.signUpMessage = action.payload;
    },
    // Reducer to clear the sign-up state, resetting errors, messages, and steps
    clearSignUpState: (state) => {
      state.signUpStep = "signUp"; // Reset sign-up step to the initial step
      state.signUpError = null; // Clear sign-up error
      state.signUpMessage = null; // Clear sign-up message
    },
  },
});

export const {
  setIsSignedIn,
  setUser,
  clearUserState,
  setSignUpStep,
  setSignUpError,
  setSignUpMessage,
  clearSignUpState,
} = authSlice.actions;

export default authSlice.reducer;
